import React from "react";
import { Col, Row } from "react-bootstrap";

import Sponsors from "components/sponsors";
import { DDILegendWithText } from "components/ddi_legend";
import { useTranslation } from "react-i18next";

const About = () => {
	const { t } = useTranslation();
	return (
		<>
			<div className="text-center mt-5">
				<h2>{t("auto.sobreAICyclin", "Sobre a iCyclin")}</h2>
			</div>
			<div className="mx-lg-5 text-justify">
				<p>{t(
					"auto.asInteracoesMedicamentosasSaoUmaConsideracaoImportanteParaOsDoentesSubmetidosATerapiaOncologicaMuitasVezesOsDoentesRecebemVariosMedicamentosComoParteDoSeuTratamentoOncologicoBemComoTerapiasAdicionaisParaControlarComorbidadesEEfeitosColateraisDoTratamento",
					"As interações medicamentosas são uma consideração importante para os doentes\n        submetidos à terapia oncológica. Muitas vezes, os doentes recebem vários medicamentos como\n        parte do seu tratamento oncológico, bem como terapias adicionais para controlar comorbidades e efeitos\n        colaterais do tratamento."
				)}</p>
				<p>
					<strong>{t(
						"auto.asInteracoesMedicamentosasDosInibidoresDeCDKSaoRelevantesPorVariasRazoes",
						"As interações medicamentosas dos inibidores de CDK são relevantes por várias\n          razões:"
					)}</strong>
				</p>
				<ul>
					<li>
						<strong>{t("auto.segurancaDoDoente", "Segurança do Doente:")}</strong>{t(
							"auto.asInteracoesMedicamentosasPodemAfetarASegurancaDoDoenteLevandoAEfeitosAdversosOuADiminuicaoDaEficaciaDoTratamento",
							"As interações medicamentosas podem afetar a\n          segurança do Doente, levando a efeitos adversos ou a diminuição da eficácia do\n          tratamento."
						)}</li>
					<li>
						<strong>{t("auto.eficaciaDoTratamento", "Eficácia do Tratamento:")}</strong>{t(
							"auto.certosMedicamentosPodemInfluenciarAAbsorcaoEAEliminacaoDosInibidoresDeCDKAfetandoASuaConcentracaoEfetiva",
							"Certos medicamentos podem influenciar a absorção\n          e a eliminação dos inibidores de CDK, afetando a sua concentração efetiva."
						)}</li>
					<li>
						<strong>{t("auto.toxicidade", "Toxicidade:")}</strong>{t(
							"auto.algumasInteracoesPodemAumentarORiscoDeToxicidadeDosInibidoresDeCDKSendoFundamentalEntenderComoOsMedicamentosInteragemEntreSi",
							"Algumas interações podem aumentar o risco de toxicidade dos\n          inibidores de CDK, sendo fundamental entender como os medicamentos interagem entre si."
						)}</li>
					<li>
						<strong>{t("auto.polimedicacao", "Polimedicação:")}</strong>{t(
							"auto.aPolimedicacaoAumentaORiscoDeInteracoesMedicamentosasOQuePodeAfetarAEficaciaDosTratamentosPrescritosCausarEfeitosAdversosIndesejadosOuInfluenciarAToxicidadeOsDoentesComCancroMuitasVezesEstaoEmTratamentoEmSimultaneoParaOutrasCondicoesMedicasNesteSentidoAGestaoDasVariasTerapeuticasEFulcralParaEvitarComplicacoesDecorrentesDasInteracoesMedicamentosas",
							"A polimedicação aumenta o risco de\n          interações medicamentosas, o que pode afetar a eficácia dos tratamentos prescritos,\n          causar efeitos adversos indesejados ou influenciar a toxicidade. Os doentes com cancro, muitas vezes,\n          estão em tratamento em simultâneo para outras condições médicas. Neste\n          sentido, a gestão das várias terapêuticas é fulcral para evitar\n          complicações decorrentes das interações medicamentosas."
						)}</li>
					<li>
						<strong>{t("auto.personalizacaoDoTratamento", "Personalização do tratamento:")}</strong>{t(
							"auto.compreenderAsInteracoesMedicamentosasPermiteAosProfissionaisDeSaudePersonalizarOTratamentoComOsInibidoresDeCDKComBaseNosMedicamentosConcomitantesDoDoenteGarantindoQueOsDoentesRecebemOMaximoBeneficioDoTratamentoQueLhesFoiPrescrito",
							"Compreender as interações\n          medicamentosas, permite aos profissionais de saúde, personalizar o tratamento com os inibidores de CDK\n          com base nos medicamentos concomitantes do doente, garantindo que os doentes recebem o máximo\n          benefício do tratamento que lhes foi prescrito."
						)}</li>
				</ul>
				<p>{t(
					"auto.osProfissionaisDeSaudeTemDeReverCuidadosamenteTodosMedicamentosDeCadaDoenteParaIdentificarPotenciaisInteracoesQuePossamOcorrerEntreOsInibidoresDeCDKEOutrosMedicamentosPorEsseMotivoSurgiuANecessidadeDeDesenvolverUmaFerramentaQuePermitaApoiarOsMedicosNaAvaliacaoDestasInteracoesDeUmaFormaRapidaSeguraEEficiente",
					"Os profissionais de saúde têm de rever cuidadosamente todos medicamentos de cada doente para\n        identificar potenciais interações que possam ocorrer entre os inibidores de CDK e outros\n        medicamentos. Por esse motivo, surgiu a necessidade de desenvolver uma ferramenta que permita apoiar os\n        médicos na avaliação destas interações de uma forma rápida, segura e\n        eficiente."
				)}</p>
				<p>{t(
					"auto.aICyclinPretendeSerUmaPlataformaIntuitivaEAcessivelParaUtilizacaoMedicaComOPropositoDeFornecerInformacoesAtualizadasSobreInteracoesMedicamentosasRelacionadasAosInibidoresDeCDK46Como",
					"A iCyclin, pretende ser uma plataforma intuitiva e acessível para utilização médica\n        com o propósito de fornecer informações atualizadas sobre interações\n        medicamentosas relacionadas aos inibidores de CDK4/6, como"
				)}<em>{t(
					"auto.palbociclibRibociclibEAbemaciclib",
					"palbociclib, ribociclib e abemaciclib"
				)}</em>.
				</p>
				<p>{t(
					"auto.pretendeseQueEstaAplicacaoSirvaDeApoioAoTrabalhoMedicoAjudandoNaTomadaDeDecisoesSobreATerapiaMaisAdequadaEmDoentesComCancroDaMama",
					"Pretende-se que esta aplicação sirva de apoio ao trabalho médico, ajudando na tomada de\n        decisões sobre a terapia mais adequada em doentes com Cancro da Mama."
				)}</p>
				<DDILegendWithText />
			</div>
			<hr className="m-5 mb-0" />
			<Sponsors />
			<hr className="m-5 mb-0" />
			<div className="mt-5 ">
				<h2>{t(
					"auto.aSociedadePortuguesaDeSenologia",
					"A Sociedade Portuguesa de Senologia"
				)}</h2>
			</div>
			<div className="mx-lg-5 text-justify">
				<Row>
					<Col xs={12} md={4} lg={3}>
						<a href="https://www.spsenologia.pt/" target="_blank" rel="noreferrer noopener">
							<img src={require("img/sps_logo.png")} alt="logo SPS" style={{ float: "left" }} />
						</a>
					</Col>
					<Col className="ps-md-5">
						<p>{t(
							"auto.aSociedadePortuguesaDeSenologiaSPSEUmaAssociacaoCientificaECulturalSemFinsLucrativosDedicadaAoEstudoEPromocaoDaInvestigacaoNoCampoDaSenologiaEmPortugal",
							"A Sociedade Portuguesa de Senologia (SPS) é uma Associação Científica e\n            Cultural, sem fins lucrativos, dedicada ao estudo e promoção da investigação no\n            campo da Senologia em Portugal."
						)}</p>
						<p>{t(
							"auto.aSenologiaEUmaAreaMedicaQueSeConcentraNoEstudoDasDoencasDaMama",
							"A senologia é uma área médica que se concentra no estudo das doenças da mama."
						)}</p>
					</Col>
				</Row>

				<p>
					<strong>{t("auto.aSPSTemComoFinalidades", "A SPS tem como finalidades:")}</strong>
				</p>
				<ul>
					<li>{t(
						"auto.desenvolverANivelNacionalOConhecimentoReferenteAGlandulaMamariaEmMedicinaEEmBiologiaComOObjetivoDeFazerProgredirNaFisiologiaPrevencaoEDiagnosticoTratamentoEReabilitacaoDaPatologiaDaMama",
						"Desenvolver a nível nacional o conhecimento referente à glândula mamária, em\n          Medicina e em Biologia, com o objetivo de fazer progredir na fisiologia, prevenção e\n          diagnóstico, tratamento e reabilitação da patologia da mama;"
					)}</li>
					<li>{t(
						"auto.desenvolverAInvestigacaoBasicaEClinicaIncentivarTrabalhosEPublicacoesOrganizarReunioesECongressosPromoverOEnsinoECoordenarAsDiversasDisciplinasInteressadas",
						"Desenvolver a investigação básica e clínica, incentivar trabalhos e\n          publicações, organizar reuniões e congressos, promover o ensino e coordenar as diversas\n          disciplinas interessadas;"
					)}</li>
					<li>{t(
						"auto.assegurarASuaParticipacaoEmSociedadesNacionaisEInternacionaisQueTenhamObjetivosIdenticos",
						"Assegurar a sua participação em Sociedades Nacionais e Internacionais que tenham objetivos\n          idênticos;"
					)}</li>
					<li>{t(
						"auto.estabelecerProgramaDeAcreditacaoEDeCertificacaoDeUnidadesDeSaudeEDeProfissionaisQueAtuemNaAreaDaSenologia",
						"Estabelecer programa de acreditação e de certificação de unidades de saúde\n          e de profissionais que atuem na área da senologia;"
					)}</li>
					<li>{t(
						"auto.organizarEMinistrarCursosDePosgraduacaoNaAreaDaSenologia",
						"Organizar e ministrar cursos de pós-graduação na área da senologia."
					)}</li>
				</ul>

				<p>
					<strong>{t(
						"auto.aSociedadePortuguesaDeSenologiaSPSEstaConstantementeEmpenhadaEmMelhorarOCuidadoMedicoParaDoentesComCancroDaMamaACriacaoDaAplicacaoICyclinDemonstraOCompromissoDaSPSEmFornecerFerramentasAvancadasParaApoiarOsMedicosNaTomadaDeDecisoesSobreATerapiaMaisApropriadaParaOsSeusDoentes",
						"A Sociedade Portuguesa de Senologia (SPS) está constantemente empenhada em melhorar o cuidado\n          médico para doentes com Cancro da Mama. A criação da aplicação iCyclin\n          demonstra o compromisso da SPS em fornecer ferramentas avançadas para apoiar os médicos na\n          tomada de decisões sobre a terapia mais apropriada para os seus doentes."
					)}</strong>
				</p>
				<p>{t("auto.saibaMaisSobreA", "Saiba mais sobre a")}{" "}
					<a href="https://www.spsenologia.pt/" target="_blank" rel="noreferrer noopener">{t("auto.sociedadePortuguesaDeSenologia", "Sociedade Portuguesa de Senologia")}</a>
					.
				</p>
				<p className="mt-4">{t(
					"auto.paraInformacaoAdicionalContacte",
					"Para informação adicional, contacte:"
				)}{" "}
					<a href="mailto:spsenologia@spsenologia.pt">spsenologia@spsenologia.pt</a>
				</p>
			</div>
		</>
	);
};

export default About;
